import angular from 'angular';
import cookies from 'angular-cookies';
import messages from 'angular-messages';
import recaptcha from 'angular-recaptcha';
import freeTrial from './controllers/freeTrial';
import login from './services/login';
import trial from './services/trial';
import thirdParty from './services/thirdParty';
import bq from './services/bq';
import Logger from './helpers/logger';

const log = new Logger();

/**
 * Define our app
 *
 * @type {angular.Module}
 */
angular
  .module('freeTrial', [
    cookies,
    messages,
    recaptcha
  ])
  .config(['vcRecaptchaServiceProvider', (vcRecaptchaServiceProvider) => {
    log.debug({
      category: 'app',
      message: 'config'
    });

    vcRecaptchaServiceProvider.setDefaults({
      key: '6Ld0-zoUAAAAAFUdJHVqRXDlutjHwbeKtnPtUc9D',
      badge: 'bottomleft',
      lang: 'en',
      size: 'invisible',
      theme: 'light',
      type: 'image'
    });
  }])
  .service('Login', login)
  .service('Trial', trial)
  .service('ThirdParty', thirdParty)
  .service('BigQuery', bq)
  .controller('freeTrialController', freeTrial);
